import Vue from 'vue'
import {
  UPDATE_RESULT_LIST,
  FETCH_RESULT_LIST,
  UPDATE_RESULT_MAP,
  FETCH_RESULT_MAP,
  UPDATE_RESULT_PERIOD,
  FETCH_RESULT_PERIOD,
  UPDATE_CATALOG,
  FETCH_CATALOG,
  UPDATE_RESULT_FILTERED,
  FETCH_RESULT_FILTERED,
  ERROR_API,
  SET_FILTER,
  ADD_RESULT_MAP
} from './constants'

const mutations = {
  [FETCH_RESULT_LIST] (state, payload) {
    // Vue.set(state, 'resultsList', [])
    // Vue.set(state, 'totalList', 0)
    Vue.set(state, 'resultsMapDetail', null)
    Vue.set(state, 'loadingList', true)
  },
  [UPDATE_RESULT_LIST] (state, payload) {
    Vue.set(state, 'resultsMapDetail', null)
    Vue.set(state, 'resultsList', payload.results)
    Vue.set(state, 'totalList', payload.total)
    Vue.set(state, 'loadingList', false)
  },
  [FETCH_RESULT_MAP] (state, payload) {
    Vue.set(state, 'resultsMap', [])
    Vue.set(state, 'totalMap', 0)
    Vue.set(state, 'loadingMap', true)
  },
  [FETCH_RESULT_PERIOD] (state, payload) {
    Vue.set(state, 'resultsPeriod', {})
    Vue.set(state, 'loadingPeriod', true)
  },
  [UPDATE_RESULT_PERIOD] (state, payload) {
    Vue.set(state, 'resultsPeriod', payload.period)
    Vue.set(state, 'loadingPeriod', false)
  },
  [UPDATE_RESULT_MAP] (state, payload) {
    Vue.set(state, 'resultsMapDetail', null)
    Vue.set(state, 'resultsMap', payload.results)
    Vue.set(state, 'totalMap', payload.total)
    Vue.set(state, 'loadingMap', false)
  },
  [FETCH_RESULT_FILTERED] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', [])
    Vue.set(payload.objectToIncrement, 'count', 0)
    Vue.set(payload.objectToIncrement, 'loading', true)
    Vue.set(state, 'resultsMapDetail', payload.id_exhibition || null)
  },
  [UPDATE_RESULT_FILTERED] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', payload.results)
    Vue.set(payload.objectToIncrement, 'count', payload.count)
    Vue.set(payload.objectToIncrement, 'loading', false)
  },
  [FETCH_CATALOG] (state, payload) {
    Vue.set(state, 'resultCatalog', {})
    Vue.set(state, 'loadingCatalog', true)
  },
  [UPDATE_CATALOG] (state, payload) {
    Vue.set(state, 'resultCatalog', payload.result)
    Vue.set(state, 'loadingCatalog', false)
  },
  [ERROR_API] (state, payload) {
    Vue.set(state, 'results', [])
    Vue.set(state, 'total', 0)
    Vue.set(state, 'error', payload.error)
  },
  [SET_FILTER] (state, payload) {
    Vue.set(state, 'filters', payload.filters)
  },
  [ADD_RESULT_MAP] (state, payload) {
    Vue.set(state.resultsMap[0], 'data', state.resultsMap[0].data.concat(payload.result[0].data))
    // Vue.set(state, 'resultsMap', payload.results)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/search/mutations.js